import React from "react";
import BillingAdmin from "./pagesadmin/billing/BillingAdmin";

const lazyWithRefresh = (importer, name) => React.lazy(async () => {
  const retryKey = `route-chunk-retry:${name}`;
  try {
    const loaded = await importer();
    sessionStorage.removeItem(retryKey);
    return loaded;
  } catch (error) {
    if (!sessionStorage.getItem(retryKey)) {
      sessionStorage.setItem(retryKey, "1");
      window.location.reload();
      return new Promise(() => {});
    }
    sessionStorage.removeItem(retryKey);
    throw error;
  }
});

const HomePage = lazyWithRefresh(() => import("./pages/homepage/HomePageIndex"), "home");
const Contact = lazyWithRefresh(() => import("./pages/contact/ContactIndex"), "contact");
const Service = lazyWithRefresh(() => import("./pages/service/ServiceIndex"), "service");
const FinalPreview = lazyWithRefresh(() => import("./pages/final-prevew/FinalPreview"), "preview");
//ADMIN
const Home = lazyWithRefresh(() => import("./pagesadmin/Home"), "admin-home");
const Product = lazyWithRefresh(() => import("./pages/product/ProductIndex"), "product");
const ServiceAdmin = lazyWithRefresh(() => import("./pagesadmin/service/ServiceIndex"), "admin-service");
const NewsAdmin = lazyWithRefresh(() => import("./pagesadmin/news/NewsIndex"), "admin-news");
const TagsAdmin = lazyWithRefresh(() => import("./pagesadmin/tags/TagsIndex"), "admin-tags");
const NewServiceAdmin = lazyWithRefresh(() => import("./pagesadmin/service/NewService"), "admin-service-new");
const EditServiceAdmin = lazyWithRefresh(() => import("./pagesadmin/service/EditService"), "admin-service-edit");

export const AppInternal = [
  { path: "/", exact: true, name: "Trang Chủ", component: HomePage },
  { path: "/trang-chu", name: "Trang Chủ", component: HomePage },
  { path: "/lien-he", name: "property", component: Contact },
  { path: "/dich-vu", name: "property", component: Service },
  { path: "/thanh-pham", name: "Thành Phẩm", component: FinalPreview },
  { path: "/san-pham", name: "Chi tiết sản phẩm", component: Product },
];
export const AdminInternal = [
  { path: "/admin", exact: true, name: "Home", component: Home },
  { path: "/dashboard", exact: true, name: "Home", component: Home },
  { path: "/hoa-don-dich-vu", name: "Hóa đơn dịch vụ", component: BillingAdmin },
  {
    path: "/quan-ly-dich-vu",
    exact: true,
    name: "Dịch vụ",
    component: ServiceAdmin,
  },
  {
    path: "/quan-ly-dich-vu/them",
    exact: true,
    name: "Thêm dịch vụ",
    component: NewServiceAdmin,
  },
  {
    path: "/quan-ly-dich-vu/chinh-sua/:id",
    exact: true,
    name: "Chỉnh sửa dịch vụ",
    component: EditServiceAdmin,
  },
  {
    path: "/tin-tuc",
    exact: true,
    name: "Tin tức",
    component: NewsAdmin,
  },
  {
    path: "/tags",
    exact: true,
    name: "Tags",
    component: TagsAdmin,
  },
];
